import { initCoreRuntime } from './platform/core.runtime.js';
import { initSessionRuntime } from './session/session.runtime.js';
import { initOnboardingRuntime } from './onboarding/onboarding.runtime.js';
import { initNavigationRuntime } from './shell/navigation.runtime.js';
import { initAndroidUikitRuntime } from './platform/android-uikit.runtime.js';
import { initHubsRuntime } from './shell/hubs.runtime.js';
import { initCoursesRuntime } from './courses/courses.runtime.js';
import { initSettingsScheduleRuntime } from './settings/settings-schedule.runtime.js';
import { initLessonRuntime } from './schedule/lesson.runtime.js';
import { initHomeworkAiRuntime } from './study/homework-ai.runtime.js';
import { initRequirementsRuntime } from './study/requirements.runtime.js';
import { initMaterialsAttendanceWikiRuntime } from './knowledge/materials-attendance-wiki.runtime.js';
import { initEventsNotesNavigatorRuntime } from './community/events-notes-navigator.runtime.js';
import { initGroupsNotificationsRuntime } from './groups/groups-notifications.runtime.js';
import { initDialogBootRuntime } from './platform/dialog-boot.runtime.js';

let initialized = false;

export async function initializeKUniRuntime() {
  if (initialized) return;
  initialized = true;
  initCoreRuntime();
  initSessionRuntime();
  initOnboardingRuntime();
  initNavigationRuntime();
  initAndroidUikitRuntime();
  initHubsRuntime();
  initCoursesRuntime();
  initSettingsScheduleRuntime();
  initLessonRuntime();
  initHomeworkAiRuntime();
  initRequirementsRuntime();
  initMaterialsAttendanceWikiRuntime();
  initEventsNotesNavigatorRuntime();
  initGroupsNotificationsRuntime();
  await initDialogBootRuntime();
}
